// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

// @generated by protobuf-ts 2.9.6 with parameter force_server_none,optimize_code_size,ts_nocheck
// @generated from protobuf file "sui/rpc/v2/balance_change.proto" (package "sui.rpc.v2", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
//
import { MessageType } from '@protobuf-ts/runtime';
/**
 * The delta, or change, in balance for an address for a particular `Coin` type.
 *
 * @generated from protobuf message sui.rpc.v2.BalanceChange
 */
export interface BalanceChange {
	/**
	 * The account address that is affected by this balance change event.
	 *
	 * @generated from protobuf field: optional string address = 1;
	 */
	address?: string;
	/**
	 * The `Coin` type of this balance change event.
	 *
	 * @generated from protobuf field: optional string coin_type = 2;
	 */
	coinType?: string;
	/**
	 * The amount or change in balance.
	 *
	 * @generated from protobuf field: optional string amount = 3;
	 */
	amount?: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class BalanceChange$Type extends MessageType<BalanceChange> {
	constructor() {
		super('sui.rpc.v2.BalanceChange', [
			{ no: 1, name: 'address', kind: 'scalar', opt: true, T: 9 /*ScalarType.STRING*/ },
			{ no: 2, name: 'coin_type', kind: 'scalar', opt: true, T: 9 /*ScalarType.STRING*/ },
			{ no: 3, name: 'amount', kind: 'scalar', opt: true, T: 9 /*ScalarType.STRING*/ },
		]);
	}
}
/**
 * @generated MessageType for protobuf message sui.rpc.v2.BalanceChange
 */
export const BalanceChange = new BalanceChange$Type();
